module.exports = __webpack_public_path__ + "media/images/favicons/icon-36x36-43b9ea311021c891fd657c92c43b7d16.png";